import { FlowParameterParams } from '~src/flow/types/FlowParameters';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';

export interface RunFlowOnOutputStepsParams {
  flowId: string;
  flowOutputStepIds: string[];
  flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
  parameterParams?: FlowParameterParams[];
}

export interface RunFlowOnOutputStepsResult extends IResult {
}

export class RunFlowOnOutputStepsRequest extends Request<RunFlowOnOutputStepsParams, RunFlowOnOutputStepsResult> {
  constructor(params: RunFlowOnOutputStepsParams) {
    super('runFlowOnOutputSteps', params);
  }
}


